// removed by extract-text-webpack-plugin
module.exports = {"base":"_3GiiO","unlock":"_2JK5C","button":"_38BBM","add":"dD_8X","tip":"_3rGzt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ActionButton/ActionButton.scss
// module id = 1780
// module chunks = 0